{
  "version": 1,
  "asset_id": "8d0dbf2b-ba01-486d-983a-aee5b95606c6",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/8d0dbf2b-ba01-486d-983a-aee5b95606c6/austin-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/8d0dbf2b-ba01-486d-983a-aee5b95606c6/austin-1280.webp",
  "original_filename": "austin-1280.webp",
  "size": 88916,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:25:45Z"
}
